<template>
  <div
    class="grid-toolbar"
    v-if="isVisible">
    <template v-if="$root.isMobile">
      <div class="filters-mobile" v-show="isOpenFilter">
        <div class="filter-mobile__header">
          <span class="title">{{L10n('filters')}}</span>
          <i class="el-icon el-icon-close" @click="isOpenFilter = false"/>
        </div>
        <div class="toolbar-filters">
          <!-- TODO: SLOT -> GRID-TOOLBAR-FILTERS -->
          <slot/>
          <el-form
            v-for="(filter, index) in filters"
            :key="`${filter.id}-${index}`"
            :class="'grid-filter-wrapper filter-toolbar-field-'+ filter.field">
            <grid-filter
              :eventID="`${gridID}-${filter.id}`"
              :config="filter"
              place="toolbar"
              @handle="handle"/>
          </el-form>
        </div>
        <div class="toolbar-filters-control">
          <button
            v-if="filters.length"
            type="button"
            @click="$emit('handleOnFilter')"
            class="btn btn-size-s">
            {{hasSomeFilterValue ? L10n('filter-clear') : L10n('filter')}}
          </button>
        </div>
      </div>
      <div class="toolbar-filters-control" v-if="!isOpenFilter">
        <button
          v-if="filters.length"
          type="button"
          @click="isOpenFilter = true"
          class="btn btn-size-s">
          {{L10n('filter')}}
        </button>
      </div>
    </template>
    <template v-else>
      <div class="toolbar-filters-wrap">
        <div class="toolbar-filters">
          <!-- TODO: SLOT -> GRID-TOOLBAR-FILTERS -->
          <slot/>
          <el-form
            v-for="(filter, index) in outputFilters"
            :key="`${filter.id}-${index}`"
            :class="'grid-filter-wrapper filter-toolbar-field-'+ filter.field">
            <grid-filter
              :eventID="`${gridID}-${filter.id}`"
              :config="filter"
              place="toolbar"
              @handle="handle"/>
          </el-form>
        </div>
        <div class="toolbar-filters__inner" v-if="innerFilters.length">
          <vertical-collapse>
            <template v-slot:title="{ toggle }">
              <el-button
                icon="el-icon-magic-stick"
                @click="toggle"
              />
            </template>
            <template>
              <el-form
                v-for="(filter, index) in innerFilters"
                :key="`${filter.id}-${index}`"
                :class="'grid-filter-wrapper filter-toolbar-field-'+ filter.field">
                <grid-filter
                  :eventID="`${gridID}-${filter.id}`"
                  :config="filter"
                  place="toolbar"
                  @handle="handle"/>
              </el-form>
            </template>
          </vertical-collapse>
        </div>
      </div>
    </template>
  </div>
</template>

<script>
export default {
  name: 'GridToolbar',
  components: {
    'grid-filter': () => import(/* webpackChunkName: 'Grid' */ './Filters/GridFilter'),
    'vertical-collapse': () => import(/* webpackChunkName: 'UI' */ '@/components/UI/VerticalCollapse')
  },
  props: {
    gridID: { type: [String, Number], required: true },
    isVisible: { type: Boolean, required: true },
    filters: { type: Array, default: () => ([]) },
    hasSomeFilterValue: { type: Boolean, required: true }
  },
  data () {
    return {
      isOpenFilter: false,
      isOpenInner: false
    }
  },
  computed: {
    outputFilters () {
      return this.filters
        .filter((item) => {
          return item.place !== 'inner'
        })
    },
    innerFilters () {
      return this.filters
        .filter((item) => {
          return item.place === 'inner'
        })
    }
  },
  methods: {
    handle () {
      this.$emit('handle', ...arguments)
    }
  }
}
</script>

<style lang="stylus">
.grid-toolbar {
  position relative
  z-index 10
  box-sizing border-box
  padding 0
  margin 0
  width: 100%
  display grid
  grid-template-columns 1fr auto
}
.toolbar-filters-wrap{
  width: 100%
  display grid
  grid-template-columns 1fr auto
}
.toolbar-filters {
  display flex
  flex-wrap wrap
  align-items flex-end
  justify-content flex-start
  padding 0
  margin 0
  .el-form-item {
    margin-bottom 0
    padding 0 0 .8rem 0
  }
}
.toolbar-filters-control {
  align-self flex-start
  margin 1.9rem 0 0 0
}
.grid-filter-wrapper {
  padding-right 1rem
  .grid-filter {
    outline none
  }
  .el-input__inner {
    font-size 1.3rem
    border none
    border-radius 0
    border-bottom 1px solid #dddee1
    padding-left .6rem

    &:focus {
      box-shadow 0 .75rem 1rem -.65rem rgba(0, 0, 0, 0.25)
    }
  }

  .grid-filter.date-multiple {
    .el-input__suffix {
      pointer-events auto
    }

    &.is-focus {
      .el-input__inner {
        box-shadow 0 .75rem 1rem -.65rem rgba(0, 0, 0, 0.25)
      }
    }
  }

  .grid-filter.string,
  .grid-filter.date-multiple {
    .el-input {
      padding-left 3.2rem
    }

    .el-input__prefix {
      .el-input__icon {
        font-size 2rem
        color #dddee1
      }
    }

    &.is-clear {
      .el-input__inner {
        color #495057
      }
    }
  }
}
// MOBILE
.filter-mobile__header{
  display flex
  justify-content space-between
  .title{
    text-transform uppercase
    font-weight bolder
  }
}
@media only screen and (max-width: 576px) {
  .grid-toolbar{
    width 100%
    padding 1.5rem .5rem
  }
  .toolbar-filters{
    flex-direction column
    .grid-filter-wrapper{
      width 100%
    }
    .grid-filter{
      width 100% !important
      min-width unset !important
      max-width unset !important
    }
  }
  .toolbar-filters-control{
    padding 0
    button{
      width 100%
    }
  }
}

</style>
